
const state = {
    channelCodeValue: '',//埋点要统计的渠道码
}

const mutations = {
    setChannelCodeValue(state, channelCodeValue) {
        state.channelCodeValue = channelCodeValue
    },
}


export default {
    namespaced: true,
    state,
    mutations,
};